/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { BitcoinTxDetails } from "./BitcoinTxDetails.ts";
import type { TransactionParty } from "./TransactionParty.ts";

export const txV1ResponseStatusEnum = {
	confirmed: "confirmed",
	pending: "pending",
	failed: "failed",
	expired: "expired",
} as const;

export type TxV1ResponseStatusEnum =
	(typeof txV1ResponseStatusEnum)[keyof typeof txV1ResponseStatusEnum];

export type TxV1Response = {
	/**
	 * @type string
	 */
	id: string;
	/**
	 * @type string
	 */
	type: string;
	/**
	 * @type string
	 */
	status: TxV1ResponseStatusEnum;
	/**
	 * @description When the transaction was first recorded/initiated.
	 * @type string, date-time
	 */
	createdAt?: string | null;
	/**
	 * @description Last update / completion timestamp.
	 * @type string, date-time
	 */
	updatedAt?: string | null;
	/**
	 * @type object
	 */
	from?: TransactionParty | null;
	/**
	 * @type object
	 */
	to?: TransactionParty | null;
	/**
	 * @type integer
	 */
	amountSats: number;
	/**
	 * @type number, float
	 */
	valueUsd: number;
	/**
	 * @description Duration of the transaction in seconds (from creation to completion). Null if start time is unavailable.
	 * @type number, float
	 */
	timeTakenSeconds?: number | null;
	/**
	 * @type string
	 */
	txid?: string | null;
	/**
	 * @type object
	 */
	bitcoinTxData?: BitcoinTxDetails | null;
};
